import { useState } from 'react';
import dynamic from 'next/dynamic';

import { Link } from '@/atoms';
import { VARIANT_MAPS } from '@/atoms/section-text/SectionText';
import { Card } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypeCardConIframePopUpProps } from './types';

const PopUpIframe = dynamic(
  () => import('../../atoms/multimedia/Iframe/PopUpIframe'),
  {
    ssr: true,
  }
);
/**
 * CardConIframePopUp
 */
export const CardConIframePopUp: FunctionComponent<
  TypeCardConIframePopUpProps
> = ({
  caption,
  description,
  image,
  title,
  iframe,
  index,
  length,
  variant,
}: TypeCardConIframePopUpProps) => {
  const [popUpOpen, setPopUpOpen] = useState(false);
  const toggle = () => {
    setPopUpOpen(!popUpOpen);
  };
  return (
    <Card
      multimediaProps={{ image: image.src }}
      key={index}
      className={`h-full ${VARIANT_MAPS[variant]}  md:ml-0 ${
        index === 0 ? 'ml-5' : ''
      } ${index === length - 1 ? 'mr-5' : ''}`}
      classNames={{ content: iframe && 'flex flex-col justify-between' }}
    >
      <div>
        {caption && (
          <span className="text-caption text-caption--small mb-2">
            {caption}
          </span>
        )}

        {iframe && (
          <PopUpIframe setState={setPopUpOpen} src={iframe} state={popUpOpen} />
        )}
        <h4 className="text-heading text-heading--h4">{title}</h4>

        {description && (
          <p className="text-body text-body--primary mt-4">{description}</p>
        )}
      </div>

      {iframe && (
        <Link className="pt-4" variant="primary" onClick={toggle}>
          Tour Virtual
        </Link>
      )}
    </Card>
  );
};

CardConIframePopUp.displayName = 'CardConIframePopUp';
